import React from "react";

const Benefits = (props) => {
  // Divide os benefícios em grupos de 3
  const chunkArray = (arr, size) => {
    return arr.length ? [arr.slice(0, size), arr.slice(size)] : [];
  };

  const benefitsChunks = props.data ? chunkArray(props.data, 3) : [];

  return (
    <div id="benefits">
      <div className="container">
        <div className="section-title text-center">
          <h2>Ganhos da Nossa Solução</h2>
        </div>
        {benefitsChunks.length > 0 ? (
          benefitsChunks.map((chunk, idx) => (
            <div key={idx} className="row justify-content-center">
              {chunk.map((benefit, index) => (
                <div key={index} className="col-md-4">
                  <div className="benefit-card">
                    <div className="benefit-icon">
                      <i className={benefit.icon}></i>
                    </div>
                    <div className="benefit-content">
                      <h3>{benefit.title}</h3>
                      <p>{benefit.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))
        ) : (
          <p>Carregando...</p>
        )}
      </div>
    </div>
  );
};

export default Benefits;
